// extracted by mini-css-extract-plugin
module.exports = {"vacationReportLayout":"-rOq5","nameWrapper":"OEv37","name":"_2aKQj"};